import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["srcset"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 0,
  class: "card-title"
}
const _hoisted_10 = {
  key: 3,
  class: "content4-p"
}
const _hoisted_11 = { href: "/case-studies" }
const _hoisted_12 = { key: 4 }

import { ref, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'imageAlt',
  props: {
    imageAltCollection: { default: () => [] },
    pAHref: {},
    center: { type: Boolean, default: false },
    span: { default: 6 },
    strong: { type: Boolean, default: false },
    h2Title: {},
    pTitle: {},
    pT: {},
    hasTailHr: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

// 获取优化后的图片URL
const getOptimizedImageUrl = (url: string, width?: number) => {
    if (!url) return '';
    
    // 处理特殊格式的URL
    if (url.includes('-!j.webp')) {
        // 我们保留后缀，确保使用原始文件名
        return url;
    }
    
    return url;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.h2Title)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.h2Title), 1))
      : _createCommentVNode("", true),
    (_ctx.pTitle != undefined && _ctx.pTitle.length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.pTitle, (item, index) => {
          return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(item), 1))
        }), 128))
      : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.pT), 1)),
    _createVNode(_component_el_row, {
      class: "content3",
      gutter: 30
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageAltCollection, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            xs: 12,
            sm: 8,
            md: 6,
            lg: 6,
            key: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: item.link,
                class: "card-thumb"
              }, [
                (item.imgUrl)
                  ? (_openBlock(), _createElementBlock("picture", _hoisted_4, [
                      _createElementVNode("source", {
                        media: "(max-width: 768px)",
                        srcset: getOptimizedImageUrl(item.imgUrl, 400),
                        type: "image/webp"
                      }, null, 8, _hoisted_5),
                      _createElementVNode("source", {
                        media: "(max-width: 1200px)",
                        srcset: getOptimizedImageUrl(item.imgUrl, 600),
                        type: "image/webp"
                      }, null, 8, _hoisted_6),
                      _createElementVNode("source", {
                        media: "(min-width: 1201px)",
                        srcset: getOptimizedImageUrl(item.imgUrl, 800),
                        type: "image/webp"
                      }, null, 8, _hoisted_7),
                      _createElementVNode("img", {
                        src: getOptimizedImageUrl(item.imgUrl, 600),
                        alt: item.alt,
                        width: "300",
                        height: "225",
                        loading: "eager",
                        class: "product-image"
                      }, null, 8, _hoisted_8)
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_3),
              (item.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_router_link, {
                      to: item.link ? item.link : ''
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    (_ctx.pAHref)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
          _createElementVNode("a", _hoisted_11, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.pAHref), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasTailHr)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_12))
      : _createCommentVNode("", true)
  ], 64))
}
}

})